export const OAUTH = 'oauth'
